import React from "react";
import "../styles/LoadingView.css";
import { withRouter } from "react-router";

function LoadingView(props: any) {
  return (
    <>
      <div id="loader-wrapper">
        <div id="loader" />
        <div className="loader-section section-left" />
        <div className="loader-section section-right" />
      </div>
    </>
  );
}

export default LoadingView;
